import React, { useEffect, useState } from 'react'
import { Alert, Box } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import { post } from '../http/restservice'
import LoadingButton from '@mui/lab/LoadingButton'
import ReactGA4 from 'react-ga4'
import PostHogTracker from '../utils/PostHogTracker'
import vector from '../assets/Auth/Vector.svg'
import vector1 from '../assets/Auth/Vector1.svg'
import { isValidPhoneNumber as matchIsValidPhoneNumber } from 'libphonenumber-js'
import PhoneInputWithCountry from '../Components/ui/phone-number-input'

const LoginPage = () => {
  const navigate = useNavigate()
  const [phoneNumber, setPhoneNumber] = useState('')
  const isValidPhoneNumber = matchIsValidPhoneNumber(phoneNumber ?? '')

  const [message, setMessage] = useState('')
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [partnerUser, setPartnerUser] = useState(false)
  const [severity, setSeverity] = useState('error')

  // const handleChange = (e) => {
  //   setPhoneNumber(e.target.value?.replace(/[^0-9]/g, ''))
  // }

  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value ?? '')
    setPartnerUser(false)
    if (message) {
      setMessage('')
      setSeverity('error')
    }
  }

  const getResponseMessage = (response) => {
    if (typeof response?.response === 'string') return response.response
    return (
      response?.response?.message ||
      response?.message ||
      'Unable to process your request. Please try again.'
    )
  }

  useEffect(() => {
    const userMobile = localStorage.getItem('access_token')

    if (userMobile) {
      if (window.utmData && window.utmData['$marketing_title']) {
        if (window.utmData['$marketing_title'] === 'Insurance') {
          navigate('/dashboard/insurance')
        } else {
          let navState = null
          if (window.utmData.navigation_state) {
            navState = JSON.parse(window.utmData.navigation_state)
            // console.log(navState)
          }
          if (window.utmData.site_url) {
            navigate(window.utmData.site_url, { state: navState })
          } else {
            navigate('/dashboard')
          }
        }
      } else {
        navigate('/dashboard')
      }
    } else {
      ReactGA4.event({
        category: 'Login',
        action: 'Login Viewed',
      })
      PostHogTracker.pageViewed('Login Page')
    }
    if (location) {
      setMessage(location.state?.message)
      setSeverity(location.state?.severity)
    }
  }, [])

  // useEffect(() => {
  //   PostHogTracker.pageViewed('Login Page')
  //   document.getElementById('component-outlined').blur()
  // }, [])

  const validateLogin = async (event) => {
    event?.preventDefault()
    if (partnerUser || !isValidPhoneNumber || loading) return

    setMessage('')
    setSeverity('error')
    setLoading(true)
    ReactGA4.event({
      category: 'Login',
      action: 'Login phone Entered',
    })

    const payload = {
      phoneNumber,
    }

    PostHogTracker.phoneNumberEntered('Login')

    try {
      const response = await post('/customerservice/v2/api/customer/validate', payload)
      setLoading(false)
      if (response?.isError) {
        setMessage(getResponseMessage(response))
        setSeverity('error')
        return
      }

      if (!response) {
        navigate('/sign-up', {
          state: {
            phoneNumber,
          },
        })
        return
      }

      if (response.isPartnerUser) {
        setMessage(response.message)
        setPartnerUser(true)
        // window.open(response.redirectUrl, '_blank')
        return
      }

      if (response.isUserActive !== undefined && !response.isUserActive) {
        navigate('/activate-account-otp', {
          state: {
            phoneNumber,
            message: 'Account is not activated. Please activate your account and try logging in.',
          },
        })
        return
      }

      if (response.isUserActive) {
        navigate('/otp', {
          state: {
            phoneNumber,
          },
        })
        return
      }

      navigate('/sign-up', {
        state: {
          phoneNumber,
        },
      })
    } catch (e) {
      setLoading(false)
      setMessage('Unable to process your request. Please try again.')
      setSeverity('error')
      return
    }
  }

  return (
    <div className='mx-auto flex w-full max-w-[360px] min-w-0 flex-col items-center justify-center lg:relative lg:min-w-[432px] lg:rounded-3xl lg:border lg:bg-white lg:px-[72px] lg:py-12'>
      <div className='flex flex-col gap-y-1 mb-6'>
        <h1 className='text-center font-IBM text-[32px] font-bold leading-10 text-black-950 lg:text-[36px]'>
          Login
        </h1>
        <p className='text-center font-IBM text-sm font-medium leading-5 text-black-400'>
          Welcome back!
        </p>
      </div>
      <div className='w-full'>
        <Grid item xs={12}>
          {!partnerUser && message && <Alert severity={severity}>{message}</Alert>}
          {partnerUser && message && (
            <Alert severity={severity}>
              This account already exists on our partner platform. Please continue on{' '}
              <a href='https://wealthelite.in/'> RedVision’s wealth lite platform. </a>
            </Alert>
          )}
        </Grid>
        <Grid item>
          <form onSubmit={validateLogin} className='flex h-min min-w-0 flex-col font-IBM'>
            <label
              htmlFor='component-outlined'
              className='required mb-1 text-xs font-semibold leading-4 text-black-500'
            >
              Mobile number
            </label>
            <PhoneInputWithCountry
              phoneNumber={phoneNumber}
              setPhoneNumber={handlePhoneNumberChange}
            />
            {/* <input
              type='number'
              id='component-outlined'
              placeholder='Enter your number'
              required
              maxLength='10'
              inputMode='numeric'
              value={phoneNumber}
              onChange={handleChange}
              onWheel={() => document.activeElement.blur()}
              onBlur={() => {
                setPartnerUser(false)
              }}
              className='flex w-full py-2 pl-3 pr-4 rounded-[8px] border border-[#D3dBEC] bg-white font-DMSans  focus:border-primary-300 shadow-[0_1.5px_4px_0_rgba(65,85,141,0.08)] outline-none transition-all'
            /> */}

            <LoadingButton
              variant='contained'
              loading={loading}
              sx={{
                mt: '24px',
                height: '40px',
                px: '12px',
                fontSize: '14px',
                lineHeight: '20px',
                fontWeight: '600',
                fontFamily: 'IBM Plex Sans',
                textTransform: 'none',
                borderRadius: '999px',
                boxShadow: '0 10px 24px rgba(40, 24, 255, 0.18)',
                '&:hover': {
                  backgroundColor: '#2818ff',
                  boxShadow: '0 10px 24px rgba(40, 24, 255, 0.18)',
                },
                '&:active': { backgroundColor: '#2818ff', boxShadow: 'none' },
                '&.Mui-disabled': {
                  backgroundColor: 'var(--fb-vulcan-300, #b0b2c9)',
                  color: '#fff',
                  opacity: 1,
                },
              }}
              className='login-btn'
              fullWidth
              type='button'
              disabled={partnerUser || !isValidPhoneNumber || loading}
              onClick={validateLogin}
            >
              Continue
            </LoadingButton>
          </form>
        </Grid>
        <Grid item xs={12} sx={{ textAlign: 'center' }}>
          <Box className='flex lg:flex-col gap-x-2 justify-center items-center mt-6'>
            <p className='font-IBM text-sm font-medium leading-5 text-black-400'>
              Don&apos;t have an account?
            </p>
            <button
              type='button'
              onClick={() => {
                PostHogTracker.buttonClicked('Sign Up Link', {
                  action: 'Sign Up',
                  page_name: 'Login',
                })
                navigate('/sign-up', {
                  state: {
                    phoneNumber,
                  },
                })
              }}
            >
              <span className='border-b-2 border-dashed border-primary-500 font-IBM text-sm font-semibold leading-5 text-primary-500'>
                Get started for free!
              </span>
            </button>
          </Box>
        </Grid>
      </div>

      <img
        className='hidden lg:block absolute top-[5%] left-[-30%] -z-[1]'
        src={vector}
        alt='Vector 1'
      />

      <img
        className='hidden lg:block absolute bottom-[-15%] right-[-12%] -z-[1]'
        src={vector1}
        alt='Vector 2'
      />
    </div>
  )
}

export default LoginPage
